import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'objectToQueryString',
  standalone: false,
})
export class ObjectToQueryStringPipe implements PipeTransform {
  transform(obj: any): any {
    return Object.keys(obj)
      .map(
        (key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`,
      )
      .join('&');
  }
}
